
import { TranslationsByLanguage } from './types';

export type ErrorsTranslationKey =
  | 'errors.pageNotFound'
  | 'errors.invalidEmail'
  | 'errors.passwordsDoNotMatch'
  | 'errors.passwordTooShort'
  | 'errors.unexpectedError'
  | 'errors.somethingWentWrong'
  | 'errors.missingToken'
  | 'errors.invalidResetUrl'
  | 'errors.resetProcessFailed'
  | 'errors.noHashFragment'
  | 'errors.tokenExtractionFailed'
  | 'creator.accessRestricted'
  | 'creator.adminOnlyUpload'
  | 'creator.featureMovedAdmin'
  | 'creator.useDerivativeInstead';

export const errorsTranslations: TranslationsByLanguage = {
  en: {
    'errors.pageNotFound': 'Page not found',
    'creator.accessRestricted': 'Access Restricted',
    'creator.adminOnlyUpload': 'Only administrators can upload new clips. Creators can create derivatives from existing clips.',
    'creator.featureMovedAdmin': 'This feature has been moved to the admin dashboard.',
    'creator.useDerivativeInstead': 'Please use the Create Derivative page instead.',
    'errors.invalidEmail': 'Please enter a valid email address',
    'errors.passwordsDoNotMatch': 'Passwords do not match',
    'errors.passwordTooShort': 'Password must be at least 6 characters',
    'errors.unexpectedError': 'An unexpected error occurred',
    'errors.somethingWentWrong': 'Something went wrong',
    'errors.missingToken': 'Missing or invalid reset token',
    'errors.invalidResetUrl': 'Invalid password reset URL format',
    'errors.resetProcessFailed': 'Password reset process failed',
    'errors.noHashFragment': 'No hash fragment found in URL',
    'errors.tokenExtractionFailed': 'Could not extract token from URL',
  },
  fr: {
    'errors.pageNotFound': 'Page non trouvée',
    'creator.accessRestricted': 'Accès Restreint',
    'creator.adminOnlyUpload': 'Seuls les administrateurs peuvent télécharger de nouveaux clips. Les créateurs peuvent créer des dérivés à partir de clips existants.',
    'creator.featureMovedAdmin': 'Cette fonctionnalité a été déplacée vers le tableau de bord administrateur.',
    'creator.useDerivativeInstead': 'Veuillez utiliser la page Créer un Dérivé à la place.',
    'errors.invalidEmail': 'Veuillez entrer une adresse email valide',
    'errors.passwordsDoNotMatch': 'Les mots de passe ne correspondent pas',
    'errors.passwordTooShort': 'Le mot de passe doit comporter au moins 6 caractères',
    'errors.unexpectedError': 'Une erreur inattendue s\'est produite',
    'errors.somethingWentWrong': 'Quelque chose s\'est mal passé',
    'errors.missingToken': 'Jeton de réinitialisation manquant ou invalide',
    'errors.invalidResetUrl': 'Format d\'URL de réinitialisation non valide',
    'errors.resetProcessFailed': 'Le processus de réinitialisation du mot de passe a échoué',
    'errors.noHashFragment': 'Aucun fragment de hachage trouvé dans l\'URL',
    'errors.tokenExtractionFailed': 'Impossible d\'extraire le jeton de l\'URL',
  }
};
